var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"switch-theme",attrs:{"disabled":_vm.disabled,"inset":"","dense":"","color":"var(--theme-color-three)","true-value":_vm.trueValue,"false-value":_vm.falseValue,"input-value":_vm.inputValue},on:{"change":_vm.eventChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }